const updateQuicksight = {
  toastr: 'Usuário atualizado',
  toastr1:' foi atualizada com sucesso',
  toastrError: 'Resposta já cadastrada',
  toastrError1: 'Insira outro nome'
};

export default updateQuicksight;
